module.exports = __webpack_public_path__ + "img/02.1bdbcd36.jpg";